import * as React from 'react';

const SvgAlertTriangleFill = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M.25 21h23.5L12 1.03.25 21ZM12 17.75a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5ZM13 14h-2V9h2v5Z" })
);

export { SvgAlertTriangleFill as default };
//# sourceMappingURL=AlertTriangleFill.es.js.map
